import React, { useState } from "react";
import { Button, Heading, Text, useColorMode } from "@chakra-ui/react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { FiMusic } from "react-icons/fi";
import { RiTimerFlashFill } from "react-icons/ri";
import { AiFillDelete } from "react-icons/ai";
import { IoCheckmarkDoneSharp } from "react-icons/io5";
import { MdFavorite } from "react-icons/md";
import { FaComment } from "react-icons/fa";

const FeaturesComponent2 = () => {
  const { colorMode } = useColorMode();
  const [selected, setSelected] = useState("timer");
  const controls = useAnimation();
  const [ref, inView] = useInView();

  React.useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [controls, inView]);
  return (
    <motion.div
      className="flex justify-center items-start w-screen h-screen flex-col md:flex-row"
      ref={ref}
      animate={controls}
      initial="hidden"
      transition={{ duration: 0.3 }}
      variants={{
        visible: { opacity: 1, scale: 1 },
        hidden: { opacity: 0, scale: 0 },
      }}
    >
      <div className="flex w-[100%] md:w-[40%] justify-center h-full flex-col gap-5 md:ml-16 ml-0 md:mt-0 mt-20">
        <Heading as="h1" fontSize="5xl" className="mb-4">
          Extra Features
        </Heading>
        {colorMode === "light" ? (
          <div className="flex flex-col w-full gap-5">
            <div
              className="flex gap-6 cursor-pointer p-2 rounded-md hover:bg-[#f0f0f0]"
              onClick={() => {
                setSelected("timer");
              }}
              style={{
                backgroundColor: selected === "timer" ? "#f0f0f0" : "",
              }}
            >
              <AiFillDelete color="#00a0dc" size="30" />
              <div className="flex flex-col items-start gap-2">
                <Heading fontSize="2xl">Trash</Heading>
                <Text fontSize="xl" color="gray.500">
                  Get all your deleted tasks
                </Text>
              </div>
            </div>
            <div
              className="flex gap-6 cursor-pointer p-2 rounded-md hover:bg-[#f0f0f0]"
              onClick={() => {
                setSelected("music");
              }}
              style={{
                backgroundColor: selected === "music" ? "#f0f0f0" : "",
              }}
            >
              <IoCheckmarkDoneSharp color="#00a0dc" size="30" />
              <div className="flex flex-col items-start gap-2">
                <Heading fontSize="2xl">Completed</Heading>
                <Text fontSize="xl" color="gray.500">
                  Get all your completed tasks
                </Text>
              </div>
            </div>
            <div
              className="flex gap-6 cursor-pointer p-2 rounded-md hover:bg-[#f0f0f0]"
              onClick={() => {
                setSelected("fav");
              }}
              style={{
                backgroundColor: selected === "fav" ? "#f0f0f0" : "",
              }}
            >
              <MdFavorite color="#00a0dc" size="30" />
              <div className="flex flex-col items-start gap-2">
                <Heading fontSize="2xl">Favourites</Heading>
                <Text fontSize="xl" color="gray.500">
                  Favourite a project to get it in a unique way
                </Text>
              </div>
            </div>
            <div
              className="flex gap-6 cursor-pointer p-2 rounded-md hover:bg-[#f0f0f0]"
              onClick={() => {
                setSelected("comments");
              }}
              style={{
                backgroundColor: selected === "comments" ? "#f0f0f0" : "",
              }}
            >
              <FaComment color="#00a0dc" size="30" />
              <div className="flex flex-col items-start gap-2">
                <Heading fontSize="2xl">Comments</Heading>
                <Text fontSize="xl" color="gray.500">
                  Comment on others projects to tell them how they are doing
                </Text>
              </div>
            </div>
          </div>
        ) : (
          <div className="flex flex-col w-full gap-5">
            <div
              className="flex gap-6 cursor-pointer p-2 rounded-md hover:bg-[#21242a]"
              onClick={() => {
                setSelected("timer");
              }}
              style={{
                backgroundColor: selected === "timer" ? "#21242a" : "",
              }}
            >
              <AiFillDelete color="#00a0dc" size="30" />
              <div className="flex flex-col items-start gap-2">
                <Heading fontSize="2xl">Trash</Heading>
                <Text fontSize="xl" color="gray.500">
                  Get all your deleted tasks
                </Text>
              </div>
            </div>
            <div
              className="flex gap-6 cursor-pointer p-2 rounded-md hover:bg-[#21242a]"
              onClick={() => {
                setSelected("music");
              }}
              style={{
                backgroundColor: selected === "music" ? "#21242a" : "",
              }}
            >
              <IoCheckmarkDoneSharp color="#00a0dc" size="30" />
              <div className="flex flex-col items-start gap-2">
                <Heading fontSize="2xl">Completed</Heading>
                <Text fontSize="xl" color="gray.500">
                  Get all your completed tasks
                </Text>
              </div>
            </div>
            <div
              className="flex gap-6 cursor-pointer p-2 rounded-md hover:bg-[#21242a]"
              onClick={() => {
                setSelected("fav");
              }}
              style={{
                backgroundColor: selected === "fav" ? "#21242a" : "",
              }}
            >
              <MdFavorite color="#00a0dc" size="30" />
              <div className="flex flex-col items-start gap-2">
                <Heading fontSize="2xl">Favourites</Heading>
                <Text fontSize="xl" color="gray.500">
                  Favourite a project to get it in a unique way
                </Text>
              </div>
            </div>
            <div
              className="flex gap-6 cursor-pointer p-2 rounded-md hover:bg-[#21242a]"
              onClick={() => {
                setSelected("comments");
              }}
              style={{
                backgroundColor: selected === "comments" ? "#21242a" : "",
              }}
            >
              <FaComment color="#00a0dc" size="30" />
              <div className="flex flex-col items-start gap-2">
                <Heading fontSize="2xl">Comments</Heading>
                <Text fontSize="xl" color="gray.500">
                  Comment on others projects to tell them how they are doing
                </Text>
              </div>
            </div>
          </div>
        )}
      </div>
      <motion.div
        className="flex w-[100%] md:w-[60%] justify-center items-center h-full"
        whileHover={{
          scale: 1.1,
        }}
      >
        {selected === "timer" ? (
          <motion.div
            initial={{
              width: 0,
            }}
            animate={{
              width: "100%",
            }}
            exit={{
              width: 0,
              transition: { delay: 0.7, duration: 0.3 },
            }}
            className="flex justify-center items-center h-full"
          >
            <img src="/images/7.png" alt="" className="w-[90%]" />
          </motion.div>
        ) : selected === "music" ? (
          <motion.div
            initial={{
              width: 0,
            }}
            animate={{
              width: "100%",
              transition: { delay: 0.7, duration: 2 },
            }}
            exit={{
              width: 0,
              transition: { delay: 0.7, duration: 0.3 },
            }}
            className="flex justify-center items-center h-full"
          >
            <img src="/images/6.png" alt="" className="w-[90%]" />
          </motion.div>
        ) : selected === "fav" ? (
          <motion.div
            initial={{
              width: 0,
            }}
            animate={{
              width: "100%",
            }}
            exit={{
              width: 0,
              transition: { delay: 0.7, duration: 0.3 },
            }}
            className="flex justify-center items-center h-full"
          >
            <img src="images/8.png" alt="" className="w-[40%]" />
          </motion.div>
        ) : (
          <motion.div
            initial={{
              width: 0,
            }}
            animate={{
              width: "100%",
            }}
            exit={{
              width: 0,
              transition: { delay: 0.7, duration: 0.3 },
            }}
            className="flex justify-center items-center h-full"
          >
            <img src="images/9.png" alt="" className="w-[80%]" />
          </motion.div>
        )}
      </motion.div>
    </motion.div>
  );
};

export default FeaturesComponent2;
